var _line, _line2, _line3, _line4, _line5, _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLineChart = function SvgLineChart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1002,
    height: 318,
    viewBox: "0 0 1002 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 248.5,
    x2: 961,
    y2: 248.5,
    stroke: "#F0F3F5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 208.5,
    x2: 961,
    y2: 208.5,
    stroke: "#F0F3F5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 168.5,
    x2: 961,
    y2: 168.5,
    stroke: "#F0F3F5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 128.5,
    x2: 961,
    y2: 128.5,
    stroke: "#F0F3F5"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 88.5,
    x2: 961,
    y2: 88.5001,
    stroke: "#F0F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 129C77.8307 129 79.3653 207 115.429 207C151.492 207 151.492 207 188.323 207C225.153 207 263.519 207 299.582 207C335.646 207 336.413 163.7 372.476 163.7C408.54 163.7 410.074 163.7 447.672 163.7C485.27 163.7 486.038 198.554 520.566 198.554C555.095 198.554 556.63 198.554 593.46 198.554C630.291 198.554 631.826 156.206 667.889 156.206C703.952 156.206 705.487 156.206 740.783 156.206C776.079 156.206 778.381 136.719 814.445 136.719C850.508 136.719 851.275 207 888.106 207C924.937 207 924.169 207 961 207",
    stroke: "#E4E8EE",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 142.623C77.8307 142.623 79.3653 121 115.429 121C151.492 121 151.492 156.703 188.323 156.703C225.153 156.703 263.519 156.703 299.582 156.703C335.646 156.703 336.413 195.423 372.476 195.423C408.54 195.423 410.074 128.543 447.672 128.543C485.27 128.543 486.038 128.543 520.566 128.543C555.095 128.543 556.63 168.269 593.46 168.269C630.291 168.269 631.826 209 667.889 209C703.952 209 705.487 187.88 740.783 187.88C776.079 187.88 778.381 168.269 814.445 168.269C850.508 168.269 851.275 149.16 888.106 149.16C924.937 149.16 924.169 187.88 961 187.88",
    stroke: "#888894",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 273,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 273,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 273,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 273,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 273,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 529,
    y: 273,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 625,
    y: 273,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 273,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 817,
    y: 273,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 913,
    y: 273,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_47_2",
    x: 35.5,
    y: 119.5,
    width: 931,
    height: 99,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.588235 0 0 0 0 0.494118 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_47_2",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLineChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "line-chart.04382652ffdafc91a85cf0a78c33cb83.svg";